import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PSPDFKit from '../pspdfkit';
import { getOrder, getReviewForms } from '../../api/choiceforms';
/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

interface FormReviewState {
  completedForms: Record<string, any>;
  client?: string;
  currentForm?: number;
  forms?: any[];
  finishedLoading?: boolean;
  pdfURL?: string;
  xfdf?: string;
  error?: boolean;
  errorMessage?: any;
}

export function FormReview() {
  const params = useParams();
  const [state, setState] = useState<FormReviewState>({
    completedForms: {}
  });

  useEffect(
    () => {
      const loadData = async () => {
        // incmoing params are client, and path
        //path will return [{pdfurl, xfdf}]
        const client = params.client;
        const formPath = params.formpath;
        try {
          const forms = await getReviewForms(client, formPath);
          console.log(forms);
          let currentForm = 0;
          const pdfURL = forms[currentForm].pdfURL;
          const xfdf = forms[currentForm].xfdf;
          console.log(pdfURL);
          console.log('done');

          setState(prevState => ({
            ...prevState,
            client,
            currentForm,
            forms,
            finishedLoading: true,
            pdfURL,
            xfdf
          }));
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setState(prevState => ({
            ...prevState,
            error: true,
            errorMessage: error
          }));
        }
      };

      loadData();
    },
    [params]
  );

  const formCompleted = async (formid, xfdf) => {
    // add formd data
  };

  const licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
  var host = `https://${state.client}`;
  if (process.env.NODE_ENV === 'development') {
    host = `http://${state.client}`;
  }
  if (state.finishedLoading) {
    const form = state.forms[state.currentForm];
    console.log('Current Form: ' + state.currentForm);
    console.log(form);
    const formUrl = `${host}${form.pdfURL}`;
    const title = `Form ${state.currentForm + 1} of ${state.forms.length}`;
    return (
      <div
        className="App"
        style={{
          backgroundColor: '#fff',
          maxWidth: '1170px',
          marginRight: 'auto',
          marginLeft: 'auto'
        }}
      >
        <img alt="form hero" src={host + '/casfiles/fillableform_hero.png'} />
        {state.error && <div>{state.errorMessage}</div>}
        {state.finishedLoading && (
          <PSPDFKit
            documentId={state.currentForm}
            pdfUrl={formUrl}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            completedForm={xfdf => {
              formCompleted('', xfdf);
            }}
            hideToolbar={true}
            title={title}
            maxWidth="1170px"
            xfdf={state.xfdf}
          />
        )}
      </div>
    );
  }
  return null;
}

export default FormReview;
